import React, { useEffect, useState } from 'react';

type Options = {
  dependencies?: unknown[];
  isInitiallyBlank?: boolean;
};

type ReactProps = {
  children: React.ReactNode;
};

/**
 * This is used to force a render when rehydrating with props that may change DOM layout.
 * For more info, https://www.joshwcomeau.com/react/the-perils-of-rehydration/
 */
function withForcedRender<WrappedComponentProps extends ReactProps>(
  WrappedComponent: React.ElementType,
  options?: Options
) {
  const Component = (props: WrappedComponentProps) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
      setMounted(true);
    }, options?.dependencies || []);

    if (options?.isInitiallyBlank && !mounted) {
      return null;
    }

    return (
      <React.Fragment key={`with-forced-render-mounted-${mounted}`}>
        <WrappedComponent {...props} />
      </React.Fragment>
    );
  };

  Component.displayName = 'withForcedRender';

  return Component;
}

export default withForcedRender;
